module.exports = __webpack_public_path__ + "static/media/NoBoundries_logo.93b8e377.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/NoBoundries_logo.svg
// module id = 308
// module chunks = 0